<template>
  <div ref="SunburstChart" style="width: 100%; height: 100%"></div>
</template>

<script>
import * as echarts from "echarts";
import { px2rem } from "@/utils/rem";
import { generateSunburstChartTooltip } from "@/utils/tooltip";

export default {
  name: "SunburstChartRound",
  emits: ["finished"],
  data() {
    return {
      chart: null,
      chartData: [],
    };
  },
  mounted() {
    // this.init();
  },
  methods: {
    init() {
      let option = {
        tooltip: {
          show: true,
          backgroundColor: "transplant",
          borderColor: "transplant",
          borderWidth: 0,
          padding: 0,
          formatter: function (params) {
            return generateSunburstChartTooltip({
              name: params.name,
              value: params.data?.textValue || params.data?.value || 0,
              primaryColor: params.color,
              borderColor: params.color,
            });
          },
        },
        series: {
          type: "sunburst",
          data: this.chartData,
          radius: ["0", "100%"],
          itemStyle: {
            borderRadius: px2rem(5),
            borderWidth: px2rem(2),
          },
          label: {
            show: true,
            rotate: "tangential",
            color: "#fff",
            fontSize: px2rem(12),
            overflow: "truncate",
          },
          labelLayout: {
            hideOverlap: true,
          },
          levels: [
            {},
            {
              r0: "25%",
              r: "60%",
            },
            {
              r0: "60%",
              r: "80%",
            },
            {
              r0: "80%",
              r: "100%",
            },
          ],
        },
        color: ["#fa8383", "#ffc164", "#61deab", "#6a98ff"],
      };

      this.chart = echarts.init(
        this.$refs.SunburstChart,
        {},
        {
          renderer: "svg",
        }
      );
      this.chart.setOption(option);
      this.chart.on("finished", () => {
        this.$emit("finished");
        this.chart.off("finished");
      });
      this.chart.on("dblclick", (params) => {
        console.log("6666", params);
        // 只有tf families 才可以双击
        if (params.treePathInfo.length === 2) {
          this.$emit("chart-dblclick", {
            level: params.treePathInfo.length + 1,
            name: params.data.name,
          });
        }
      });
    },
    setData(data) {
      this.chartData = data;
      this.chart && this.chart.dispose();
      this.init();
    },
  },
  beforeDestroy() {
    // 在组件销毁前，销毁 ECharts 实例
    this.chart && this.chart.dispose();
  },
};
</script>

<style lang="scss" scoped></style>
